import React from 'react'
import '../Project.css';
import Image1 from '../../Gemco-Website-Images/projects/The_D1_tower.webp';

const Project_one = () => {

  return (
    <>

      <div className='project_1_work' id="workBanner">

        <div className="container project_our_work">

          <div className="heading">
            <h1>D1 Tower</h1>
          </div>

          <hr></hr>
          <div className='project_section'>
            <div className="project_section_content">
              <h1 className="project_scope">Scope of Work</h1>
              <p>A landmark supertall residential tower on Dubai Creek forming part of the Mohammed Bin Rashid City development. D1 Tower
                offers luxury residences with panoramic creek and skyline views, positioned as one of Dubai's most prominent new waterfront
                addresses.</p>
              <p>MAIN CONTRACTOR : -</p>
              <p>MEP CONTRACTOR : Kele & Hastie</p>
              <p>GEMCO SCOPE OF WORKS : Full MEP installation — major scope</p>
              {/* <h2 className="project_years">2014 – 2022</h2> */}
            </div>
            <div className='project_1_card'>
              <img className="project_one_image" width="500" height="300" src={Image1} alt="Project" />
            </div>
          </div>
        </div>
      </div>

    </>


  )
}

export default Project_one